//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    text: {
      type: String,
      default: '',
      required: false,
    },
    button: {
      type: Object,
      default() {
        return { icon: 'arrow-right' }
      },
    },
    buttonText: {
      type: Object,
      default() {},
    },
    smallText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'PageCallToAction',
    },
    visibility: {
      type: Array,
      default: null,
    },
    anchorId: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible() {
      return (
        this.visible ||
        this.$store.state?.user?.group.some((item) =>
          this.visibility?.includes(item)
        )
      )
    },
  },
  methods: {
    login() {
      if (this.userBranch !== '') {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'login-button-click',
          'event-category': 'button-click',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }

      // this.$auth.loginWith('auth0')
      window.location.href = 'https://community.hearpeers.com/login'
    },
  },
}
